/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../../common/header/Header";
import Footer from "../../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      em: "em",
      a: "a"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Security Overview"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Security Overview"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsx(_components.h2, {
                    children: "We protect your data."
                  }), _jsx(_components.p, {
                    children: "All data are written to multiple disks instantly, backed up daily, and stored in multiple\nlocations. Files that our customers upload are stored on servers that use modern techniques\nto remove bottlenecks and points of failure."
                  }), _jsx(_components.h2, {
                    children: "Your data are sent using HTTPS."
                  }), _jsx(_components.p, {
                    children: "Whenever your data are in transit between you and us, everything is encrypted, and sent\nusing HTTPS. Within our firewalled private networks, data may be transferred unencrypted."
                  }), _jsx(_components.p, {
                    children: "Any files which you upload to us are stored and are encrypted at rest. Our application\ndatabases are generally not encrypted at rest — the information you add to the applications\nis active in our databases and subject to the same protection and monitoring as the rest of\nour systems. Our database backups are encrypted using GPG."
                  }), _jsx(_components.h2, {
                    children: "Regularly-updated infrastructure."
                  }), _jsx(_components.p, {
                    children: "Our software infrastructure is updated regularly with the latest security patches. Our\nproducts run on a dedicated network which is locked down with firewalls and carefully\nmonitored."
                  }), _jsx(_components.h2, {
                    children: "We protect your billing information."
                  }), _jsxs(_components.p, {
                    children: ["All credit card transactions are processed using secure encryption—the same level of\nencryption used by leading banks. Card information is transmitted, stored, and processed\nsecurely on a ", _jsx("a", {
                      href: "https://en.wikipedia.org/wiki/Payment_Card_Industry_Data_Security_Standard",
                      children: "PCI-Compliant\nnetwork"
                    }), "."]
                  }), _jsx(_components.h2, {
                    children: "Constant monitoring"
                  }), _jsxs(_components.p, {
                    children: ["We have a team dedicated to maintaining your account’s security on our systems and\nmonitoring tools we’ve set up to alert us to any nefarious activity against our domains. To\ndate, we’ve ", _jsx(_components.em, {
                      children: "never"
                    }), " had a data breach."]
                  }), _jsx(_components.p, {
                    children: "We also audit internal data access. If a Modulabs employee wrongly accesses customer data,\nthey will face penalties ranging from termination to prosecution."
                  }), _jsx(_components.p, {
                    children: "We have processes and defenses in place to keep our streak of 0 data breaches going. But in\nthe unfortunate circumstances someone malicious does successfully mount an attack, we will\nimmediately notify all affected customers."
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
